import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

/**
 * Retrieve the configurations governing a district's restrictions of its students being able to search.
 */
const useStudentSearchRestrictionsGet = () => {
  const requestUrl = `${API_BASE_URL}/api/v3/visibility/content-settings-search-message/`;
  return useRestQuery(requestUrl);
};

export default useStudentSearchRestrictionsGet;
